export default __webpack_public_path__ + "static/media/69t.5877c934.jpg";